import {IGraphUser} from '../interfaces';

export class Users {
  public cacheById: {[id: string]: Promise<IGraphUser | undefined> | undefined} = {};
}
